import imgURL from '../../../lib/imgURL';
import { PRODUCTS, UiRoutes } from '../../../lib/constants';
import { Product } from './typing';
import { getMerchnatVersionFromStore } from '../../../lib/helper';

const merchantVersion = getMerchnatVersionFromStore();

export const productsExtraDetails = [
  {
    id: 1,
    image: imgURL['console-logo'],
    product: PRODUCTS.EDGE,
    route:  merchantVersion === 'V3' ? UiRoutes.V3_PAYMENTS : UiRoutes.EDGE_OVERVIEW,
  },
  {
    id: 2,
    image: imgURL['gateway-logo'],
    product: PRODUCTS.ROUTER,
    route: UiRoutes.OVERVIEW,
  },
  {
    id: 3,
    image: imgURL['payout-icon'],
    product: PRODUCTS.PAYOUT,
    route: UiRoutes.INDIVIDUAL_PAYOUTS,
  },
  {
    id: 4,
    image: imgURL['subscription-icon'],
    product: PRODUCTS.SUBSCRIPTIONS,
    route: UiRoutes.V3_PLANS,
  },
];

export const getProductData = (product: Product) : any => {
  return productsExtraDetails.find((item) => item?.id === product?.id);
};

export const mappedProductsData = [
  {
    id: 2,

    mid: '14400',

    name: 'Plural Console',

    status: '2',
  },
  {
    id: 3,

    mid: '14401',

    name: 'Plural Gateway',

    status: '2',
  },
];

export const dummy = [
  {
    id: 1,
    mid: '14401',
    name: 'Plural Gateway',
    status: 2,
    description:
      'Plural Gateway is a secure, user-friendly payment gateway designed to give you exactly what you need to sell online',
    image: imgURL['console-logo'],
    product: PRODUCTS.EDGE,
    route: UiRoutes.EDGE_TRANSACTIONS,
  },
  {
    id: 2,
    mid: '14400',
    name: 'Plural Console',
    status: 2,
    description:
      'Use our plug & play platform to instantly get customers starting their recurring payments',
    image: imgURL['gateway-logo'],
    product: PRODUCTS.ROUTER,
    route: UiRoutes.UNIFIED_MERCHANT_LISTING,
  },
  {
    id: 3,
    mid: '14400',
    name: 'Plural Payouts',
    status: 2,
    description:
      'Use our plug & play platform to instantly get customers to starting their recurring payments.',
    image: imgURL['payout-icon'],
    product: PRODUCTS.PAYOUT,
    route: UiRoutes.INDIVIDUAL_PAYOUTS,
  },
];
